import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FolhaServicoExterna } from 'src/app/models/folha-servico-externa';

@Injectable({
  providedIn: 'root'
})
export class PapeletaExternaService {

  private http = inject(HttpClient);

  buscarPapeletaExterna(matricula: number, dataServico: string): Observable<FolhaServicoExterna[]> {
    const params = new HttpParams()
      .set('matricula', matricula.toString())
      .set('dataServico', dataServico);

    return this.http.get<FolhaServicoExterna[]>(
      `/folha-servico/externo/por-data-matricula`,
      { params }
    );
  }
}